
import Message from "iview/src/components/message";

export default http => {
  // 请求拦截
  http.interceptors.request.use(
    config => {
      // config.withCredentials = true; // 需要跨域打开此配置
      config.headers = {'username': localStorage.getItem('dsp_username')};
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  )
  // https://github.com/mzabriskie/axios#interceptors
  http.interceptors.response.use(
    response => {
      return response.data;
    },
    /**
     * This is a central point to handle all
     * error messages generated by HTTP
     * requests
     */
    error => {
      if (!error['response']) {
        return Promise.reject(error)
      }
      switch (error.response.status) {
        case 401:
          Message.error('请先登录');
          setTimeout(function () {
            window.location.href = '/login';
          }, 5000);
          break;
        case 404:
          Message.error('404');
          break;
        case 429:
          Message.error('请求过于频繁');
          break;
        case 419:
        case 502:
        case 503:
        default:
          Message.error('error');
      }
      return Promise.reject(error.response);
    }
  )
}




// WEBPACK FOOTER //
// ./src/http/dsp_request.js